import { render, staticRenderFns } from "./TutorialesCaja.vue?vue&type=template&id=a9bdd282&scoped=true"
import script from "./TutorialesCaja.vue?vue&type=script&lang=js"
export * from "./TutorialesCaja.vue?vue&type=script&lang=js"
import style0 from "./TutorialesCaja.vue?vue&type=style&index=0&id=a9bdd282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bdd282",
  null
  
)

export default component.exports